/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { simplifyQueryValue } from 'js/lib/queryUtils';
import { useLocation } from 'js/lib/useRouter';

import OtherTopics from 'bundles/browse-common/legacy/components/Domain/OtherTopics';
import type { Subdomain } from 'bundles/browse-common/legacy/components/Domain/types/SubDomain';
import { seoMetaTitleExceptions } from 'bundles/browse-common/utils/seo';
import type { Domain } from 'bundles/browse/components/Domain/types/Domain';
import BrowseFAQs from 'bundles/browse/components/Faq/BrowseFAQs';
import { getCurrentPageFromRouter } from 'bundles/browse/utils';

const style = () => css`
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;

  &::before,
  &::after {
    display: table;
    content: ' ';
  }

  &::after {
    clear: both;
  }

  @media (min-width: 768px) {
    width: 750px;
  }

  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1200px) {
    width: 1170px;
  }

  margin-top: 60px;
  margin-bottom: 61px;

  .internal-linking-container {
    margin: 0 auto 75px;
    max-width: 885px;

    @media (max-width: 1023) {
      margin: auto;
    }
  }
`;

type PropsFromCaller = {
  domain: Domain;
  subdomain?: Subdomain;
};

const BrowseInternalLinking = ({ domain, subdomain }: PropsFromCaller) => {
  const location = useLocation();
  const seoDomainName = `${domain.name} Online Courses`;
  let seoSubDomainName = '';

  if (subdomain) {
    seoSubDomainName = `${subdomain.name} Online Courses`;
  }

  let metaTitle = subdomain ? seoSubDomainName : seoDomainName;
  if (seoMetaTitleExceptions.includes(metaTitle)) {
    metaTitle += ' Certificates';
  }
  const subdomainName = subdomain?.name;
  const currentPage = getCurrentPageFromRouter(simplifyQueryValue(location.query.page) ?? ''); // TODO handle null/undefined case
  const isOnFirstPage = currentPage === 1;

  return (
    <div className="rc-BrowseInternalLinking body-container" data-testid="browse-internal-linking" css={style}>
      <div className="internal-linking-container">
        {isOnFirstPage && <BrowseFAQs appSlug="browse" faqTopic={subdomainName || domain.name} />}
        <OtherTopics />
      </div>
    </div>
  );
};

export default BrowseInternalLinking;
